import script from "./CustomQuotesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomQuotesForm.vue?vue&type=script&setup=true&lang=js"

import "./CustomQuotesForm.vue?vue&type=style&index=0&id=1b4908fe&lang=scss"

const __exports__ = script;

export default __exports__